import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { AuthService } from 'src/app/auth/_service/auth.service';

@Pipe({ name: 'valuta' })
export class ValutaPipe implements PipeTransform {
	constructor(private auth: AuthService) {}
	transform(_: any) {
		if (!this.auth.getUser() || !this.auth.getUser().cliente || !this.auth.getUser().cliente.mercato[0]) {
			return '*';
		}

		const mercati = this.auth.getUser().cliente.mercato.map((m) => m.codiceMercato);

		if (mercati.includes('USA') || mercati.includes('US') || mercati.includes('CA')) {
			return '$';
		}

		if (
			mercati.includes('HU') ||
			mercati.includes('NL') ||
			mercati.includes('AU') ||
			mercati.includes('IT') ||
			mercati.includes('SE') ||
			mercati.includes('RU') ||
			mercati.includes('IL') ||
			mercati.includes('EU') ||
			mercati.includes('GB') ||
			mercati.includes('GE')
		) {
			return '€';
		}

		return '*';
	}
}
